import styled, { css } from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants.js'

export const StaticBannerContainer = styled.div`
  display: flex;
  max-width: 400px;
  padding: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};

  border: 1px solid;
  border-radius: 8px;

  ${({ variantStyles }) => css`
    ${variantStyles}
  `}
`
